import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Events from './components/Events';
import Clubs from './components/Clubs';
import Athletes from './components/Athletes';
import Referees from './components/Referees';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import LoginAdmin from './components/LoginAdmin';
import AdminDashboard from './components/AdminDashboard';
import AdminClubManager from './components/AdminClubManager';
import PublicAthletes from './components/PublicAthletes';
import AdminFees from './components/AdminFees';
import PublicCoaches from './components/PublicCoaches';
import PublicReferees from './components/PublicReferees';
import PublicClubs from './components/PublicClubs';
import PublicEvents from './components/PublicEvents';
import ResetPassword from "./components/ResetPassword";
import ForgotPassword from "./components/ForgotPassword";
import AdminClubReferees from './components/AdminClubReferees';
import AdminClubCoaches from './components/AdminClubCoaches';
import Footer from './components/Footer';
import AdminClubAthletes from './components/AdminClubAthletes';
import CCHLogin from './components/CCHLogin';
import CCHDashboard from './components/CCHDashboard';
import CCHCreateEvent from './components/CCHCreateEvent';
import CCHEventsList from './components/CCHEventsList';
import ProtectedCCH from './components/ProtectedCCH';
import AdminClubEvents from './components/AdminClubEvents';
import Contact from './components/Contact';
import AdminProfile from './components/AdminProfile';

import './App.css';

function Home() {
  return (
    <div className="gooutdoor-bg">
      <div class="navbar">
        <Link to="/login" className="gooutdoor-login-btn">Log in</Link>
      </div>
      <div className="gooutdoor-hero">
        <div className="gooutdoor-hero-content">
          <h1>Federația Română de Orientare</h1>
          <p>
            Aplicatie
          </p>
          <a
            href="https://www.fro.ro/federatia-romana-de-orientare/istoric"
            target="_blank"
            rel="noopener noreferrer"
            className="gooutdoor-hero-btn"
          >
            Află mai multe despre noi
          </a>

        </div>
        <div className="gooutdoor-hero-img"></div>
      </div>
      <div className="gooutdoor-wave">
        <svg
          viewBox="0 0 1440 120"
          width="100%"
          height="120"
          style={{ display: 'block' }}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,80 Q180,120 360,60 Q540,0 720,60 Q900,120 1080,60 Q1260,0 1440,60"
            fill="none"
            stroke="#ffb625"
            strokeWidth="4"
            strokeDasharray="16,12"
          />
        </svg>
      </div>
      <div className="gooutdoor-section-title">
        <h2></h2>
      </div>
      <div className="gooutdoor-tiles-row plant-card-row">
        <Link to="/publicevents" className="plant-card">
          <div className="plant-card-img events-image">
          </div>
          <div className="plant-card-content">
            <div>
              <div className="plant-card-title">Evenimente</div>
              <div className="plant-card-desc">Competiții și calendar</div>
            </div>
            <button className="plant-card-arrow">&#8594;</button>
          </div>
        </Link>
        <Link to="/publicclubs" className="plant-card">
          <div className="plant-card-img clubs-image">

          </div>
          <div className="plant-card-content">
            <div>
              <div className="plant-card-title">Cluburi sportive</div>
              <div className="plant-card-desc">Descoperă cluburile</div>
            </div>
            <button className="plant-card-arrow">&#8594;</button>
          </div>
        </Link>
        <Link to="/publicreferees" className="plant-card">
          <div className="plant-card-img referees-image">
          </div>
          <div className="plant-card-content">
            <div>
              <div className="plant-card-title">Arbitri</div>
              <div className="plant-card-desc">Lista arbitrilor</div>
            </div>
            <button className="plant-card-arrow">&#8594;</button>
          </div>
        </Link>
        <Link to="/publicathletes" className="plant-card">
          <div className="plant-card-img athletes-image">
          </div>
          <div className="plant-card-content">
            <div>
              <div className="plant-card-title">Sportivi</div>
              <div className="plant-card-desc">Toți sportivii legitimați</div>
            </div>
            <button className="plant-card-arrow">&#8594;</button>
          </div>
        </Link>
        <Link to="/publiccoaches" className="plant-card">
          <div className="plant-card-img coach-image">
          </div>
          <div className="plant-card-content">
            <div>
              <div className="plant-card-title">Antrenori</div>
              <div className="plant-card-desc">Toți antrenorii legitimați</div>
            </div>
            <button className="plant-card-arrow">&#8594;</button>
          </div>
        </Link>
      </div>
      <div className="gooutdoor-section-title">
        <h2></h2>
      </div>
      <div className="gooutdoor-bottom-wave"></div>
      {/* 🔹 Footer comun */}
      <Footer />
    </div>
  );
}




const buttonStyle = {
  display: 'block',
  width: '100%',
  padding: '10px 0',
  margin: '10px 0',
  fontSize: '18px',
  cursor: 'pointer'
};

function App() {
  return (
    <Router basename="/app">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/clubs" element={<Clubs />} />
        <Route path="/referees" element={<Referees />} />
        <Route path="/athletes" element={<Athletes />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<LoginAdmin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/clubs" element={<AdminClubManager />} />
        <Route path="/admin/taxes" element={<AdminFees />} />
        <Route path="/publicathletes" element={<PublicAthletes />} />
        <Route path="/publiccoaches" element={<PublicCoaches />} />
        <Route path="/publicreferees" element={<PublicReferees />} />
        <Route path="/publicclubs" element={<PublicClubs />} />
        <Route path="/publicevents" element={<PublicEvents />} />
<Route path="/publicevents/:eventId" element={<PublicEvents />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin/clubs/:id/athletes" element={<AdminClubAthletes />} />
        <Route path="/admin/clubs/:id/referees" element={<AdminClubReferees />} />
        <Route path="/admin/clubs/:clubId/coaches" element={<AdminClubCoaches />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/admin/clubs/:clubId/events"
          element={<AdminClubEvents />}
        />

        <Route path="/cch/login" element={<CCHLogin />} />
        <Route
          path="/cch/dashboard"
          element={<ProtectedCCH><CCHDashboard /></ProtectedCCH>}
        />

        <Route
          path="/cch/events"
          element={<ProtectedCCH><CCHEventsList /></ProtectedCCH>}
        />

        <Route
          path="/cch/events/create"
          element={<ProtectedCCH><CCHCreateEvent /></ProtectedCCH>}
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}


export default App;
